import * as React from "react";
import { Box, Container, Paper, Typography } from "@mui/material";

export default function WelcomePage() {
  return (
    <Box
      sx={{
        minHeight: "90vh",
        display: "flex",
        alignItems: "center",
        bgcolor: "background.default",
        py: 6,
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={2} sx={{ p: { xs: 4, sm: 6 }, borderRadius: 3 }}>
          <Typography variant="h4" fontWeight={700}>
            Welcome to TicketView
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5 }}>
            We’re glad you’re here.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}